import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import {
  getChannelImage,
  getPlatFormImage,
  LIST_CHANNEL_REDEEM_OPTION,
  LIST_OPTION_PLATFORM,
  LIST_REDEEM_STATUS_OPTION,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatISOString } from "helpers/format";
import CollapseFilter from "components/Common/CollapseFilter";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import CopyWrapper from "components/Common/CopyWrapper";
import { getLoggedInUserInfo } from "api/axiosClient";
import redeemCodeApi from "api/redeemCodeApi";
import DropdownAsyncAgency from "components/Common/DropdownAsyncAgency";
import DropdownPlatform from "components/Common/DropdownPlatform";
import DropdownChannel from "components/Common/DropdownChannel";

import { capitalizeFirstLetter } from "utils";
import { getRedeemCodeUsageList } from "store/redeemCodeUsage/thunk";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "claimed_at";

registerLocale("en", en);
registerLocale("ko", ko);

const RedeemCodeUsage = () => {
  const { t, i18n } = useTranslation();
  const [summary, setSummary] = useState<any>(null);
  const data = getLoggedInUserInfo();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    page_size: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    user_name: withDefault(StringParam, ""),
    user_email: withDefault(StringParam, ""),
    redeem_code: withDefault(StringParam, ""),
    status: withDefault(StringParam, "used"),
    agency_id: withDefault(StringParam, ""),
    channel: withDefault(StringParam, ""),
    created_from: withDefault(StringParam, ""),
    created_to: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, "claimed_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.created_from
      ? moment(query?.created_from || "", "Y-MM-DD").toDate()
      : null,
    query?.created_to
      ? moment(query?.created_to || "", "Y-MM-DD").toDate()
      : null,
  ]);
  const [startDate, endDate] = dateSearch;
  const [selectedAgency, setSelectedAgency] = useState<any>({
    label: t("All"),
    value: "",
  });

  const [platFormSearch, setPlatFormSearch] = useState<Option | null>(
    LIST_OPTION_PLATFORM?.filter(
      (item) => String(item?.value) === String(query?.provider)
    )[0]
  );

  const [redeemCodeSearch, setRedeemCodeSearch] = useState<string>(
    query?.redeem_code || ""
  );

  const [nameSearch, setNameSearch] = useState<string>(query?.name || "");

  const [emailSearch, setEmailSearch] = useState<string>(query?.email || "");

  const [agencySearch, setAgencySearch] = useState<Option | any>("");
  const [channelSearch, setChannelSearch] = useState<Option | any>("");

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.RedeemCodeUsage;
  const RedeemCodeProperties = createSelector(selectLayoutState, (state) => ({
    lstRedeemCode: state.lstRedeemCodeUsage,
    isRedeemCodeLoading: state.isRedeemCodeUsageLoading,
    isRedeemCodeSuccess: state.isRedeemCodeUsageSuccess,
    error: state.error,
  }));

  // Inside your component
  const { lstRedeemCode, isRedeemCodeLoading } =
    useSelector(RedeemCodeProperties);

  function loadTableData() {
    dispatch(getRedeemCodeUsageList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      redeem_code: redeemCodeSearch,
      status: "used",
      channel: channelSearch?.value || "",
      user_provider: platFormSearch,
      agency_id: agencySearch === "all" ? "" : agencySearch,
      user_name: nameSearch,
      user_email: emailSearch,
      created_from: startDate ? formatISOString(startDate, "start") : "",
      created_to: endDate ? formatISOString(endDate, "end") : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        redeem_code: "",
        status: "used",
        channel: "",
        agency_id: "",
        user_name: "",
        user_email: "",
        created_from: "",
        created_to: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setRedeemCodeSearch("");
    setNameSearch("");
    setEmailSearch("");
    setSelectedAgency({ label: t("All Filter"), value: "" });
    setChannelSearch("");
    setPlatFormSearch({ label: t("All Filter"), value: "" });
    setDateSearch([null, null]);
  };

  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: "40px" }}>
              {lstRedeemCode?.pagination?.total -
                ((query?.page - 1) * query?.page_size + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        thWidth: 60,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.value;
          return (
            <div className="d-flex justify-content-center">
              <div
                className={`text-center rounded-pill badge mx-auto text-white bg-${
                  LIST_REDEEM_STATUS_OPTION.find((i) => item === i?.value)
                    ?.value
                }`}
                dir="ltr"
              >
                {
                  LIST_REDEEM_STATUS_OPTION.find((i) => item === i?.value)
                    ?.label
                }
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Redeem Code"),
        accessor: "code",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Courses"),
        accessor: "courses",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          return cell?.value?.length
            ? cell?.value?.map((i: any) =>
                i?.name ? (
                  <div className="badge bg-primary">{i?.name}</div>
                ) : null
              )
            : "-";
        },
      },
      {
        Header: t("Agency Code"),
        accessor: "agency.code",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Agency Name"),
        accessor: "agency.name",
        filterable: false,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer" style={{ minWidth: 150 }}>
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Channel"),
        accessor: "channel",
        filterable: false,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.value;
          return (
            <div className="gap-2 d-flex" style={{ minWidth: 150 }}>
              <img src={getChannelImage(item)} alt="channelImage" height={20} />
              {LIST_CHANNEL_REDEEM_OPTION.find((i) => item === i?.value)?.label}
            </div>
          );
        },
      },
      {
        Header: t("Name"),
        accessor: "starplus_user.name",
        filterable: false,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer" style={{ minWidth: 150 }}>
                {`${cell?.value}`}
              </div>
            )
          );
        },
      },
      {
        Header: t("Email"),
        accessor: "starplus_user.email",
        filterable: false,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer" style={{ minWidth: 150 }}>
                {`${cell?.value}`}
              </div>
            )
          );
        },
      },
      {
        Header: t("Platform"),
        accessor: "starplus_user.provider",
        thWidth: 140,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          let provider = cell?.value;

          let imgPlatform = getPlatFormImage(provider);
          return (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="provider"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    capitalizeFirstLetter(
                      provider === "default" ? "Email" : provider
                    )
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
      // {
      //   Header: t("Payment Method"),
      //   accessor: "payment_method",
      //   thWidth: 140,
      //   thClass: "text-center  whitespace-nowrap",
      //   Cell: (cell: any) => {
      //     const item: any = cell?.row?.original;
      //     return (
      //       <div
      //         className="form-check form-switch form-switch-sm text-center"
      //         dir="ltr"
      //       >
      //         {
      //           LIST_PAYMENT_METHOD_OPTION.find(
      //             (i) => item === i?.value || "cash" === i?.value
      //           )?.label
      //         }
      //       </div>
      //     );
      //   },
      // },
      {
        Header: t("Actived Date"),
        accessor: "claimed_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, lstRedeemCode?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const getSummary = async () => {
    try {
      const response: any = await redeemCodeApi.getRedeemCodeSumary(query);
      setSummary(response?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Agency Management")} | Picaverse Agency Star+`;
    document.body.classList.remove("vertical-sidebar-enable");
    getSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Redeem Code Issue")} pageTitle={t("Home")} />
          {
            <Row>
              <Col lg={12}>
                <Card
                  id="customerList"
                  style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                >
                  <CardHeader className="border-0">
                    <div className="d-block d-xl-flex justify-content-between align-items-start">
                      <div className="col-5 con-sm-6">
                        <div>
                          <h5 className="card-title mb-0">
                            <span className="me-2">{t("Total")}:</span>
                            <CountUp
                              start={0}
                              end={summary?.used || 0}
                              duration={1}
                              className="text-primary"
                            />
                          </h5>
                        </div>
                      </div>

                      {/* <div className="col-sm-auto">
                        <button
                          type="button"
                          className="btn btn-success d-none d-md-block"
                          onClick={() => {
                            setIsOpen(true);
                            setItemToEdit(null);
                          }}
                        >
                          <i className="ri-add-fill align-bottom me-1"></i>{" "}
                          {t("Button Create Redeem Code")}
                        </button>
                      </div> */}
                    </div>
                  </CardHeader>

                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                    <CollapseFilter>
                      <Row className="g-4 align-items-center mt-0 mt-md-3">
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-3"
                        >
                          <LabelWrapper
                            label={`${t("Redeem Code")}`}
                            isShow={!!redeemCodeSearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Redeem Code")}...`}
                              value={redeemCodeSearch}
                              onChange={(e) =>
                                setRedeemCodeSearch(e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        {data?.user?.role === "admin" && (
                          <Col
                            sm={12}
                            md={3}
                            xl={3}
                            xxl={3}
                            className="mt-3 mt-md-3"
                          >
                            <LabelWrapper label={t("Agency")} isShow={true}>
                              {/* <DropdownOption
                              name="agency"
                              dataList={AgencyList}
                              placeholder={`${t("Select Agency")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={
                                AgencyList?.find(
                                  (i: any) => i.id == agencySearch
                                ) || null
                              }
                              onChangeSelect={(e: any) => {
                                setAgencySearch(e?.value);
                              }}
                              isHasOptionAll={true}
                              optionAll={{ label: t("All Filter"), value: "" }}
                            /> */}
                              <DropdownAsyncAgency
                                name="agency"
                                onChangeSelect={(event: any) => {
                                  setAgencySearch(event?.value);
                                  setSelectedAgency(event);
                                }}
                                isMulti={false}
                                placeholder={`${t("Select Agency")}...`}
                                isShowIconCheck={false}
                                listCheckedUsers={selectedAgency}
                                isAllOption={true}
                                isNotBelongToAgency={false}
                                isClearable={false}
                              />
                            </LabelWrapper>
                          </Col>
                        )}
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-3"
                        >
                          <LabelWrapper label={t("Channel")} isShow={true}>
                            {/* <DropdownOption
                              name="channel"
                              dataList={LIST_CHANNEL_REDEEM_OPTION}
                              placeholder={`${t("Select Channel")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={
                                LIST_CHANNEL_REDEEM_OPTION?.find(
                                  (i: any) => i.value == channelSearch
                                ) || {
                                  label: t("All"),
                                  value: "all",
                                }
                              }
                              onChangeSelect={(e: any) => {
                                setChannelSearch(e?.value);
                              }}
                              isHasOptionAll={true}
                              optionAll={{ label: t("All"), value: "" }}
                            /> */}
                            <DropdownChannel
                              name="channel"
                              placeholder={`${t("Select Channel")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={channelSearch || null}
                              onChangeSelect={(e: any) => setChannelSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t("All Filter"), value: "" }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-3"
                        >
                          <LabelWrapper
                            label={`${t("Name")}`}
                            isShow={!!nameSearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Name")}...`}
                              value={nameSearch}
                              onChange={(e) => setNameSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-3"
                        >
                          <LabelWrapper
                            label={`${t("Email")}`}
                            isShow={!!emailSearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Email")}...`}
                              value={emailSearch}
                              onChange={(e) => setEmailSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                        >
                          <LabelWrapper label={t("Platform")} isShow={true}>
                            <DropdownPlatform
                              name="provider"
                              placeholder={`${t("Platform")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={platFormSearch || null}
                              onChangeSelect={(e: any) => setPlatFormSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t("All Filter"), value: "" }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                        >
                          <LabelWrapper
                            label={t("Date Range")}
                            isShow={!!startDate || !!endDate}
                          >
                            <DatePickerCustom
                              startDate={startDate || null}
                              endDate={endDate || null}
                              onChangePicker={handleChangePicker}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col
                          sm={12}
                          md={12}
                          xl={12}
                          xxl={12}
                          className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-3 mt-md-3"
                        >
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary me-1"
                              onClick={searchData}
                            >
                              <i className="ri-search-line align-bottom me-1"></i>{" "}
                              {t("Button Search")}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary fs-14"
                              onClick={resetData}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                              {t("Button Reset")}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CollapseFilter>
                  </div>
                  <CardBody className="pt-3">
                    <div>
                      <TableContainer
                        className="custom-header-css"
                        divClass="table-responsive table-card"
                        tableClass="align-middle table-bordered-dashed"
                        theadClass="table-light text-muted"
                        columns={columns}
                        data={
                          lstRedeemCode?.items?.length
                            ? lstRedeemCode?.items
                            : []
                        }
                        customPageSize={query.page_size}
                        customPageIndex={query.page - 1}
                        totalRecords={lstRedeemCode?.pagination?.total}
                        customPageCount={Math.ceil(
                          Number(lstRedeemCode?.pagination?.total) /
                            Number(query.page_size)
                        )}
                        handleChangePage={handleChangePage}
                        manualSorting={true}
                        sorting={{
                          sort_by: query.sort_by,
                          order_by: query.order_by,
                        }}
                        handleChangeSorting={handleChangeSorting}
                        isLoading={isRedeemCodeLoading}
                      />
                    </div>
                    <ToastContainer closeButton={false} limit={1} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RedeemCodeUsage;
